import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative w-full xl:h-[290px] md:h-[180px] mb-2 md:mb-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "absolute bottom-[10px] left-[10px] mr-[10px] gap-2 flex flex-wrap max-w-[calc(100%-20px)]" }
const _hoisted_4 = { class: "sf-pro font-semibold text-base leading-[21px] xl:text-2xl xl:leading-8 max-h-[84px] md:max-h-14 xl:max-h-max line-clamp-3 md:line-clamp-2 xl:line-clamp-none text-brown group-hover/container:text-active text-left mb-2 transition-colors duration-300 ease-in-out" }
const _hoisted_5 = { class: "sf-pro text-sm font-normal leading-[21px] md:text-base md:leading-[24px] xl:leading-[28px] text-muted text-left mb-2" }
const _hoisted_6 = { class: "sf-pro text-sm font-normal leading-[21px] md:text-base md:leading-[24px] xl:text-2xl xl:leading-[28px] text-brown text-left mb-4 md:line-clamp-3 line-clamp-4" }


import { BlogCardItem } from "@/types/blogs";
import { useLangStore } from "@/stores/langStore";
import OpenButton from "@/components/buttons/OpenButton.vue";
import BlogCardTag from "@/views/Blogs/components/BlogCard/BlogCardTag.vue";
import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogCard',
  props: {
    blog: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const router = useRouter();
const langStore = useLangStore();

function openBlog() {
  router.push({ name: ROUTE_NAMES.BLOG_DETAIL, params: { id: props.blog.id } });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card-container group/container cursor-pointer",
    onClick: openBlog
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: props.blog.cardImageUrl,
        alt: "blog card image",
        class: "w-full h-full rounded-[20px] object-cover aspect-video"
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.blog.tags, (tag) => {
          return (_openBlock(), _createBlock(BlogCardTag, {
            "tag-name": tag[_unref(langStore).current] || tag[_unref(langStore).fallbackLang],
            "bg-image": props.blog.cardImageUrl,
            key: tag.id
          }, null, 8, ["tag-name", "bg-image"]))
        }), 128))
      ])
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(props.blog.titles[_unref(langStore).current] ||
        props.blog.titles[_unref(langStore).fallbackLang]), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(props.blog.createdAt), 1),
    _createElementVNode("p", _hoisted_6, _toDisplayString(props.blog.shortDescriptions[_unref(langStore).current] ||
        props.blog.shortDescriptions[_unref(langStore).fallbackLang]), 1),
    _createVNode(OpenButton, {
      label: _unref(t)('blog.read_more'),
      type: "brown-outline",
      "hover-container": "active-outline",
      "hover-type": "active"
    }, null, 8, ["label"])
  ]))
}
}

})